import DateFnsUtils from "@date-io/date-fns";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import React from "react";

const DateRangeSelector = ({start, end, onChange, variant, style}) => {
    const startDate = new Date(start * 1000);
    const endDate = new Date(end * 1000);

    const startDateChanged = newDate => {
        onChange([newDate.getTime() / 1000, end]);
    };

    const endDateChanged = newDate => {
        onChange([start, newDate.getTime() / 1000]);
    };

    return (
        <div style={{display: "flex", justifyContent: "space-around", ...style}}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>

                <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"
                    margin="normal"
                    disableFuture={true}
                    label="Start Date"
                    value={startDate}
                    onChange={startDateChanged}
                    KeyboardButtonProps={{
                        "aria-label": "change date"
                    }}
                    inputVariant={variant}
                />

                <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"
                    disableFuture={true}
                    margin="normal"
                    label="End Date"
                    value={endDate}
                    onChange={endDateChanged}
                    KeyboardButtonProps={{
                        "aria-label": "change date"
                    }}
                    inputVariant={variant}
                />
            </MuiPickersUtilsProvider>
        </div>
    );
};

export default DateRangeSelector;